export const EnumTyC = {
    WarninLegal: "AvisoLegal",
    PrivacyPolicy:"PolíticaDePrivacidad",
    Cookies:"PolíticaDeCookies"
};